export default "__VITE_ASSET__E4meU9Z1__"